import { render, staticRenderFns } from "./ModalAddFolio.vue?vue&type=template&id=08979a86&"
import script from "./ModalAddFolio.vue?vue&type=script&lang=js&"
export * from "./ModalAddFolio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports